import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OpenIdConfiguration } from "angular-auth-oidc-client";
import { Observable, of, tap } from "rxjs";

@Injectable({
  providedIn: 'root'
})
/**
  Environmanet configuration service
*/
export class ConfigService {
  private _config: EnvironmentConfig | null = null;
  private _httpClient: HttpClient;

  constructor(handler: HttpBackend) {
    // Injected HttpBackend, this way insetad of directly injecting HttpClient because we have
    // httpInterceptor that will eagrly load other service dependend of the config
    this._httpClient = new HttpClient(handler);
  }

  /** Load Environment Config on runtime */
  public loadConfig(): Observable<EnvironmentConfig> {
    if (this._config) {
      return of(this._config);
    }

    return this._httpClient.get<EnvironmentConfig>('./assets/environments/environment.json')
      .pipe(
        tap(r => this._config = r)
      );
  }

  public getConfig<T>(key: string): T {
    let config: any = this._config as any;
    return (this._config ? config[key] : '') as T;
  }
}

export interface EnvironmentConfig {
  api_url: string;
  fromEmail: string;
  identity: OpenIdConfiguration;
}
